module.exports = __webpack_public_path__ + "static/media/InspectingTooth.a6c8a2a1.png";